import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getVehicleStatus = async () => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicles/status`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch vehicle status data:", error);
    throw error;
  }
};

export { getVehicleStatus };
